<template>
  <v-container fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" md="8">
        <p>Hoi</p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Home",
  components: {}
};
</script>
